module.exports = __webpack_public_path__ + "static/pic02-5b91fcff905d574076a3b860d00682f5.jpg";